import breakpoints from '../styles/exportBreakpoints.module.scss';

const breakpointsList = Object.entries(breakpoints).reverse();

export default (screenWidth) => (
  breakpointsList.find((breakpoint) => screenWidth >= parseInt(breakpoint[1], 10))?.[0]
);
